import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Tooltip } from '@material-ui/core';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import { Flex, SvgIcon, Text } from 'Components/Base';

const useToolTipStyles = makeStyles({
  popper: {
    zIndex: 1,
  },
  tooltip: ({ colors, space, fonts }) => ({
    fontFamily: fonts.sans,
    background: colors.primary,
    color: colors.white,
    margin: `${space[2]}px ${space[0]}px`,
    borderRadius: '8px',
  }),
  arrow: ({ colors }) => ({
    color: colors.primary,
  }),
});

const ClearTooltip = ({ children, onClick, isShow }) => {
  const { colors, space, fonts } = useTheme();
  const childEl = useRef(null);
  const tooltipClasses = useToolTipStyles({ colors, space, fonts });
  const { t } = useTranslation('classroom');
  return (
    <Tooltip
      interactive
      title={
        <Flex alignItems={'center'} justifyContent="center" onClick={onClick}>
          <Flex mr={2}>
            <SvgIcon icon={SvgIcon.ICON_LIST.INFO_OUTLINED} size={12} color="text.textWhite" />
          </Flex>
          <Text textStyle={'body2'} fontWeight={'normal'} color="text.textWhite">
            {t('CLEAR_BY_ONDEMAND.BUTTON_TOOLTIP')}
          </Text>
        </Flex>
      }
      classes={tooltipClasses}
      open={isShow && childEl?.current?.clientHeight > 0}
      placement={'bottom-end'}
      arrow
    >
      <Flex ref={childEl}>{children}</Flex>
    </Tooltip>
  );
};

ClearTooltip.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.oneOf([PropTypes.string, PropTypes.node]),
  isShow: PropTypes.bool,
};

ClearTooltip.defaultProps = {
  onClick: () => {},
};

export default ClearTooltip;
